import { render, staticRenderFns } from "./AdColumn.vue?vue&type=template&id=571a7ea6&"
import script from "./AdColumn.vue?vue&type=script&lang=js&"
export * from "./AdColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports